import { validateExportTables, } from '@common/dataExport';
export function defaultExportSelections(datasets) {
    return datasets.filter((dataset) => dataset.defaultColumns.length > 0)
        .map((dataset) => ({ dataset: dataset.id, columns: [...dataset.defaultColumns] }));
}
export function selectExportColumns(table, selection) {
    const indices = selection.columns.map((id) => {
        const index = table.columns.findIndex((column) => column.id === id);
        if (index < 0)
            throw new Error(`Unknown export column: ${id}`);
        return index;
    });
    return {
        ...table,
        columns: indices.map((index) => table.columns[index]),
        rows: table.rows.map((row) => indices.map((index) => row[index])),
    };
}
export function createExportFile(tables, format, signal) {
    validateExportTables(tables);
    signal.throwIfAborted();
    return new Promise((resolve, reject) => {
        const worker = new Worker(new URL('./exportWorker.ts', import.meta.url));
        const cleanup = () => {
            worker.terminate();
            signal.removeEventListener('abort', abort);
        };
        const abort = () => {
            cleanup();
            reject(new Error('Export cancelled.'));
        };
        signal.addEventListener('abort', abort, { once: true });
        worker.onmessage = ({ data }) => {
            cleanup();
            if (data.ok)
                resolve(data.file);
            else
                reject(new Error(data.error));
        };
        worker.onerror = () => {
            cleanup();
            reject(new Error('Could not generate the export file. Try a smaller export.'));
        };
        worker.postMessage({ tables, format });
    });
}
export async function downloadExport(tables, format, filename, signal) {
    const file = await createExportFile(tables, format, signal);
    signal.throwIfAborted();
    const { saveAs } = await import('file-saver');
    signal.throwIfAborted();
    saveAs(new Blob([file.bytes], { type: file.mime }), `${filename}.${file.extension}`);
}
